// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3g4sW","info":"PatientInfo_info__1BaNN"};